import { useMemo } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import axios from "axios";
import { useLang } from "../i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || "";

export default function PayPalCheckout({ token, booking, onSuccess, onError }) {
  const { t, lang } = useLang();

  const scriptOptions = useMemo(
    () => ({
      "client-id": PAYPAL_CLIENT_ID,
      currency: booking.currency || "USD",
      intent: "capture",
      // "enable-funding": "venmo" is on by default for US clients; explicit include:
      "enable-funding": "venmo,card,paylater",
      locale: lang === "es" ? "es_MX" : "en_US",
    }),
    [booking.currency, lang]
  );

  if (!PAYPAL_CLIENT_ID) {
    return (
      <div
        data-testid="paypal-not-configured"
        className="rounded-lg bg-amber-500/10 border border-amber-500/40 p-4 text-amber-300 text-sm"
      >
        ⚠ {t("paypal_not_configured")}
      </div>
    );
  }

  const createOrder = async () => {
    const r = await axios.post(
      `${API}/p/${token}/bookings/${booking.id}/paypal/create-order`
    );
    return r.data.order_id;
  };

  const onApprove = async () => {
    try {
      const r = await axios.post(
        `${API}/p/${token}/bookings/${booking.id}/paypal/capture-order`
      );
      onSuccess?.(r.data);
    } catch (e) {
      onError?.(e?.response?.data?.detail || "Payment error");
    }
  };

  return (
    <div data-testid={`paypal-checkout-${booking.id}`}>
      <PayPalScriptProvider options={scriptOptions}>
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "rect", label: "pay" }}
          createOrder={createOrder}
          onApprove={onApprove}
          onError={(err) => onError?.(err?.message || "PayPal error")}
          onCancel={() => onError?.("cancelled")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
